<section class="lg-container">
  <form [formGroup]="reportsForm" class="flex-direction-column" layout>
    <cc-box>
      <div class="lg-container header" header box>
        <span translate>LEAD_GENERATION.REPORTS</span>
        <a
          class="export-button"
          color="primary-full"
          mat-raised-button
          download
          filename="filename"
          [attr.href]="reportUrl">
          <span translate>LEAD_GENERATION.EXPORT</span>
        </a>
        <button
          class="pull-right"
          mat-raised-button
          (click)="toggleLiveMode()"
          color="primary"
          *ngIf="false">
          <span translate>LEAD_GENERATION.LIVE_MODE</span>
        </button>
      </div>

      <div content box>
        <div class="lg-container flex-between align-item-center">
          <div class="w-35 right-margin">
            <div class="header-label" translate>LEAD_GENERATION.DATE</div>
            <div class="range-live-wrapper">
              <span title="{{dateFrom}} - {{dateTo}}" class="text-ellipsis">{{dateFrom}} - {{dateTo}}</span>
              <span class="live text-ellipsis" *ngIf="liveModeEnabled" translate>LEAD_GENERATION.LIVE</span>
            </div>

          </div>
          <div class="w-30 horizontal-margin">
            <div class="header-label" translate>LEAD_GENERATION.PROJECTS.TITLE</div>
            <div *ngIf="projectsAreSelected" [title]="selectedProjects" class="text-ellipsis">{{selectedProjects}}</div>
            <div *ngIf="!projectsAreSelected" translate>LEAD_GENERATION.NONE</div>
          </div>
          <div class="w-30">
            <i class="material-icons pointer pull-right"
               (click)="changeExpandedState()"
               [ngClass]="{ 'primary-text': isExpanded }"
            >tune</i>
          </div>
        </div>

        <div class="lg-container flex-between border-top align-item-center content" *ngIf="isExpanded">
          <label translate>LEAD_GENERATION.DATE</label>
          <div class="w-30">
            <cc-date-range-picker (selected)="changeDateRange($event)"
                                  [endDate]="datePickerEndDate"
                                  [maxDate]="datePickerEndDate"
                                  class="date-range-input"
            >
            </cc-date-range-picker>
          </div>
        </div>

        <div class="lg-container border-top flex-between align-item-center content" layout *ngIf="isExpanded">
          <label translate>LEAD_GENERATION.PROJECTS.TITLE</label>
          <mat-select
            formControlName="projects"
            placeholder="{{'LEAD_GENERATION.CHOOSE' | translate}}"
            class="w-30"
            multiple
          >
            <mat-option disabled="disabled" class="option-menu">
              <div (click)="selectAllProjects()" class="pointer option-menu-item" translate>LEAD_GENERATION.SELECT_ALL
              </div>
              <div (click)="unselectAllProjects()" class="pointer option-menu-item" translate>
                LEAD_GENERATION.UNSELECT_ALL
              </div>
            </mat-option>
            <mat-option
              *ngFor="let item of projects"
              [value]="item.id"
            >{{item.name}}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </cc-box>

    <div class="button-wrapper" *ngIf="isExpanded">
      <button
        [disabled]="!projectsAreSelected"
        mat-raised-button
        (click)="onSubmit()"
        color="primary">
        <span translate>LEAD_GENERATION.SUBMIT</span>
      </button>
    </div>

  </form>
</section>
